import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import ArtistRepresentationReducer from '../reducers/index';

const configureStore = (railsProps) => (
  createStore(ArtistRepresentationReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;